import { Reveal } from "./Reveal";
import { PROCESS } from "../../data/content";

export const Process = () => (
  <section id="ablauf" data-testid="process-section" className="py-20 md:py-28 bg-[#F5F2ED]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <p className="text-[#B5651D] text-xs uppercase tracking-[0.25em] font-semibold mb-4">
          So einfach geht's
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1F2933]">
          In 4 Schritten zum neuen Raum
        </h2>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PROCESS.map((p, i) => (
          <Reveal key={p.step} delay={i * 0.15}>
            <div
              data-testid={`process-step-${i}`}
              className="relative bg-white border border-[#E5E1D8] p-8 h-full transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              <span className="font-heading font-bold text-5xl text-[#C9B79C]/60">{p.step}</span>
              <h3 className="font-heading font-semibold text-xl text-[#1F2933] mt-4">{p.title}</h3>
              <p className="mt-3 text-sm text-[#4B5563] leading-relaxed">{p.text}</p>
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-[#B5651D] transition-all duration-500 group-hover:w-full" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
